import React, { Component } from 'react';
import styled from 'styled-components';
import FeatureCarouselItem from './FeatureCarouselItem';
import CarouselControl from './CarouselControl';
import i18n from '../../../config/i18n';
import photos from './photos';
import icons from './icons';

const StyledWrap = styled.div`
  position: relative;
  width: 100%;
  left: 0;
  zIndex: 0;
`;

const StyledListItem = styled.li`
  margin: 0;
  padding-bottom: 18px;
`;

const Link = styled.a`
  color: #1a57a5;
  text-decoration: none;
  &:hover {
    color: #1a57a5;
    text-decoration: none;
  }
`;

const featuresCount = 8;
class FeatureCarousel extends Component {
  state = {
    activeItem: 0,
  };

  componentDidMount() {
    this.startTimer();
  }

  async componentDidUpdate(nextProps, nextState) {
    if (nextState.activeItem !== this.state.activeItem) {
      await this.clearAndStartTimer();
    }
  }

  async componentWillUnmount() {
    await clearInterval(this.intervalId);
  }

  onPrev = () => {
    this.setState(({ activeItem }) => (
      {
        // activeItem: activeItem === 0 ? features.length - 1 : activeItem - 1,
        activeItem: activeItem === 0 ? featuresCount - 1 : activeItem - 1,
      }
    ));
  };

  onNext = () => {
    this.setState(({ activeItem }) => (
      {
        // activeItem: activeItem === features.length - 1 ? 0 : activeItem + 1,
        activeItem: activeItem === featuresCount - 1 ? 0 : activeItem + 1,
      }
    ));
  };

  paginationHandler = (key) => {
    this.setState({
      activeItem: key,
    });
  };

  clearAndStartTimer = async () => {
    await this.clearTimer();
    await this.startTimer();
  };

  startTimer() {
    this.intervalId = setInterval(() => {
      this.setState(({ activeItem }) => (
        {
          // activeItem: activeItem === features.length - 1 ? 0 : activeItem + 1,
          activeItem: activeItem === featuresCount - 1 ? 0 : activeItem + 1,
        }
      ));
    }, 8000);
  }

  clearTimer() {
    clearInterval(this.intervalId);
  }

  renderFeatureCarouselItems = features => (
    features.map((feature, index) => (
      <FeatureCarouselItem
        feature={feature}
        key={feature.title}
        active={this.state.activeItem === index}
      />)
    )
  );

  render() {
    // to make i18n working, we have to init features in render()
    // once features changes, please remember to update featuresCount
    const features = [
      {
        title: i18n.t('benefit_1_title'),
        descriptions: [
          <StyledListItem key={1}>
            {i18n.t('benefit_1_desc1_1')}
            <b> ({i18n.t('GuruListingsTM')}) </b>
            {i18n.t('benefit_1_desc1_2')}
          </StyledListItem>,
          <StyledListItem key={2}>
            {i18n.t('benefit_1_desc2')}
          </StyledListItem>,
          <StyledListItem key={3}>
            {i18n.t('benefit_1_desc3')}
          </StyledListItem>,
        ],
        photo: photos[0],
        icon: icons[0],
      },
      {
        title: i18n.t('benefit_2_title'),
        descriptions: [
          <StyledListItem key={1}>
            {i18n.t('benefit_2_desc1')}
          </StyledListItem>,
          <StyledListItem key={2}>
            {i18n.t('benefit_2_desc2')}
          </StyledListItem>,
          <StyledListItem key={3}>
            <b>{i18n.t('GuruGaitTM')}</b>
            {i18n.t('benefit_2_desc3')}
          </StyledListItem>,
          <StyledListItem key={4}>
            <b>{i18n.t('WoundPhotosDiaryTM')}</b>
            {i18n.t('benefit_2_desc4')}
          </StyledListItem>,
        ],
        photo: photos[1],
        icon: icons[1],
      },
      {
        title: i18n.t('benefit_3_title'),
        descriptions: [
          <StyledListItem key={1}>
            <Link href="/">
              <b>{i18n.t('iHealthCareCloudsTM')}</b>
            </Link>
            {i18n.t('benefit_3_desc1_1')}
            <Link href="https://itunes.apple.com/us/app/guruwounds/id1227365622 ">
              <b>{i18n.t('GuruSyncQTM')}</b>
            </Link>
            {i18n.t('benefit_3_desc1_2')}
          </StyledListItem>,
          <StyledListItem key={2}>
            {i18n.t('GuruChatTM')}
            {i18n.t('benefit_3_desc2')}
          </StyledListItem>,
          <StyledListItem key={3}>
            {i18n.t('benefit_3_desc3')}
          </StyledListItem>,
          <StyledListItem key={4}>
            {i18n.t('benefit_3_desc4')}
          </StyledListItem>,
        ],
        photo: photos[2],
        icon: icons[2],
      },
      {
        title: i18n.t('benefit_4_title'),
        descriptions: [
          <StyledListItem key={1}>
            {i18n.t('benefit_4_desc1')}
          </StyledListItem>,
          <StyledListItem key={2}>
            {i18n.t('benefit_4_desc2')}
          </StyledListItem>,
          <StyledListItem key={3}>
            {i18n.t('benefit_4_desc3')}
          </StyledListItem>,
        ],
        photo: photos[3],
        icon: icons[3],
      },
      {
        title: i18n.t('benefit_5_title'),
        descriptions: [
          <StyledListItem key={1}>
            {i18n.t('benefit_5_desc1')}
          </StyledListItem>,
          <StyledListItem key={2}>
            {i18n.t('benefit_5_desc2')}
          </StyledListItem>,
          <StyledListItem key={3}>
            <Link href="mailto:ws@ihealthcareclouds.com">
              {i18n.t('contact_us')}
            </Link>
            {i18n.t('benefit_5_desc3')}
          </StyledListItem>,
        ],
        photo: photos[4],
        icon: icons[4],
      },
      {
        title: i18n.t('benefit_6_title'),
        descriptions: [
          <StyledListItem key={1}>
            {i18n.t('benefit_6_desc1')}
          </StyledListItem>,
          <StyledListItem key={2}>
            {i18n.t('benefit_6_desc2')}
          </StyledListItem>,
        ],
        photo: photos[5],
        icon: icons[5],
      },
      {
        title: i18n.t('benefit_7_title'),
        descriptions: [
          <StyledListItem key={1}>
            {i18n.t('benefit_7_desc1_1')}
            <Link href="/subscription">
              <b>{i18n.t('iHealthCareCloudsTM')}</b>
            </Link>
            {i18n.t('benefit_7_desc1_2')}
          </StyledListItem>,
          <StyledListItem key={2}>
            {i18n.t('benefit_7_desc2')}
          </StyledListItem>,
          <StyledListItem key={3}>
            {i18n.t('benefit_7_desc3')}
          </StyledListItem>,
          <StyledListItem key={4}>
            {i18n.t('benefit_7_desc4')}
          </StyledListItem>,
        ],
        photo: photos[6],
        icon: icons[6],
      },
      {
        title: i18n.t('benefit_8_title'),
        descriptions: [
          <StyledListItem key={1}>
            <Link href="https://itunes.apple.com/us/app/guruwounds/id1227365622 ">
              <b>{i18n.t('GuruSyncQTM')}</b>
            </Link>
            {i18n.t('benefit_8_desc1')}
          </StyledListItem>,
          <StyledListItem key={2}>
            <Link href="https://itunes.apple.com/us/app/guruwounds/id1227365622 ">
              <b>{i18n.t('GuruSyncQTM')}</b>
            </Link>
            {i18n.t('benefit_8_desc2')}
          </StyledListItem>,
          <StyledListItem key={3}>
            <b>{i18n.t('GuruChatTM')}</b>
            {i18n.t('benefit_8_desc3')}
          </StyledListItem>,
          <StyledListItem key={4}>
            {i18n.t('benefit_8_desc4')}
          </StyledListItem>,
        ],
        photo: photos[7],
        icon: icons[7],
      },
    ];
    return (
      <StyledWrap>
        {this.renderFeatureCarouselItems(features)}
        <CarouselControl
          length={features.length}
          onPrev={this.onPrev}
          onNext={this.onNext}
          onPagination={this.paginationHandler}
          activeItem={this.state.activeItem}
        />
      </StyledWrap>
    );
  }
}

export default FeatureCarousel;



// WEBPACK FOOTER //
// ./src/components/landing/FeatureCarousel/index.js